import { render, staticRenderFns } from "./involvedPlaceChat.vue?vue&type=template&id=6000daf4&"
import script from "./involvedPlaceChat.vue?vue&type=script&lang=js&"
export * from "./involvedPlaceChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports